import axios from 'axios';
import VueGallery from 'vue-gallery';

export default {
    components: {
        gallery: VueGallery,
    },
    data() {
        return {
            imagePath: 'https://show.guyanalive.com/',
            events: [],
            title: '',
            errors: [],
            index: null,
        };
    },
    created() {
        window.scrollTo(0, 0);
        this.getEvents();
    },
    methods: {
        getEvents() {
            axios
                .get(
                    'https://show.guyanalive.com/index.php?album=Flyers&json&pagination=off',
                )
                .then((response) => {
                    // JSON responses are automatically parsed.
                    this.events = response.data.album.images;
                    if (this.events) {
                        this.events.map((event) => {
                            event.href = this.imagePath + event.url_full;
                            return event;
                        });
                    }
                    this.title = response.data.album.title;
                })
                .catch((e) => {
                    this.errors.push(e);
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/events/event.page.js